const actionTypes = { STORE_INITIALISATION: 'STORE_INITIALISATION' };

module.exports = actionTypes;
